import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/system';
import { Previous, useUploader } from '@europrocurement/flexy-components';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { CollectionDeDossierCollectiondossierRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import SelectSociete from '../components/SelectSociete';
import { useParcoursFormalite, useParcoursFormalitreHeader } from '../provider';
import { parcoursFormalitePathResolver } from '../parcoursFormalitePathResolver';
import CurrentFormalityAndClient from '../components/currentFormalityAndClient';

const StepSelectionClient: React.FunctionComponent = function () {
    const { idFormalites, create, containerWidth, setLoading, back, validate } =
        useParcoursFormalite();

    React.useEffect(() => {
        setLoading(false);
    }, [setLoading]);

    const { clearFiles } = useUploader();

    const navigate = useNavigate();

    const onPrevious = () => {
        navigate(parcoursFormalitePathResolver('stepFormalite'));
    };

    const { changeParcoursSteps, setIsParcoursPath } = useParcoursFormalitreHeader();

    const { setProfileHeaderVisible } = useFullLayout();
    React.useEffect(() => {
        changeParcoursSteps(1);
        setProfileHeaderVisible(false);
        setIsParcoursPath(true);
        return () => {
            setIsParcoursPath(false);
            setProfileHeaderVisible(true);
        };
    }, [setProfileHeaderVisible, changeParcoursSteps, setIsParcoursPath]);

    /**
     * If parcours is run from back, the dossier creation will be done at this step,
     * the user will land on the validation page
     *
     * @param collection CollectionDeDossierCollectiondossierRead
     */
    const handleSubmit = async (collection: CollectionDeDossierCollectiondossierRead) => {
        if (back) {
            // Parcours form back, validate dossier
            const res = await validate(collection);

            if (res.data.dossiers) {
                // Navigate to dossier validation page
                navigate(`/dossiers/${res.data.dossiers[0].id}/validation`);
            } else {
                navigate(`/dossiers`);
            }
        } else {
            navigate(parcoursFormalitePathResolver('stepForm'));
        }
    };

    return (
        <Container maxWidth={containerWidth}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '32px',
                }}
            >
                <CurrentFormalityAndClient />
                <Previous onClick={onPrevious} />
            </Box>
            <SelectSociete
                onSelect={async (ids, sousClients) => {
                    setLoading(true);
                    const collection = await create(ids, idFormalites, sousClients[0]);
                    clearFiles();
                    handleSubmit(collection);
                }}
            />
        </Container>
    );
};

export default StepSelectionClient;
